import _slicedToArray from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import _regeneratorRuntime from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/regenerator";
import _asyncToGenerator from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\Users\\Johan\\workspace\\resurrected\\common\\temp\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import Pipeline from './pipeline';
import Mesh from './mesh';
import { mat4, vec3, mat3 } from 'gl-matrix';
export var ERROR_CHECKING = {
  NONE: 0,
  SOME: 1,
  ALL: 2
};
export var GlassContext =
/*#__PURE__*/
function () {
  function GlassContext(canvasElement) {
    var errorChecking = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ERROR_CHECKING.ALL;

    _classCallCheck(this, GlassContext);

    var glContext = canvasElement.getContext('webgl2', {
      antialias: false,
      stencil: true
    });

    if (!glContext) {
      throw new Error("Could not initialize WebGL2. Unsupported by browser?");
    }

    var ext = glContext.getExtension("EXT_color_buffer_float");

    if (!ext) {
      throw new Error("EXT_color_buffer_float unsupported in this browser");
    }

    this.canvasElement = canvasElement;
    this.errorChecking = errorChecking;
    this.gl = glContext;
    this.pipelines = {};
    this.looping = false;
    this.frameId = 0;
    this.internalCreateUnitQuad();
    this.internalCreateUnitCube();
    this.internalCreateCentered2x2Cube();
  }

  _createClass(GlassContext, [{
    key: "createPipeline",
    value: function createPipeline(name, topRenderer) {
      var pipeline = new Pipeline(this, name, topRenderer);
      this.pipelines[name] = pipeline;
      return pipeline;
    }
  }, {
    key: "startAnimationLoop",
    value: function startAnimationLoop(frameCallback) {
      var _this = this;

      this.looping = true;

      var animate = function animate() {
        _this.resizeCheck();

        var frameInfo = {
          frameId: _this.frameId,
          timestampMS: Date.now()
        };

        if (frameCallback) {
          frameCallback(frameInfo);
        }

        for (var _i = 0, _Object$values = Object.values(_this.pipelines); _i < _Object$values.length; _i++) {
          var pipeline = _Object$values[_i];
          pipeline.render(frameInfo);
        }

        if (_this.looping) {
          requestAnimationFrame(animate);
        }

        _this.frameId += 1;
      };

      requestAnimationFrame(animate);
    }
  }, {
    key: "stopAnimationLoop",
    value: function stopAnimationLoop() {
      this.looping = false;
    }
  }, {
    key: "resizeCheck",
    value: function resizeCheck() {
      var canvasElement = this.canvasElement;
      var displayWidth = canvasElement.clientWidth;
      var displayHeight = canvasElement.clientHeight;

      if (canvasElement.width !== displayWidth || canvasElement.height !== displayHeight) {
        canvasElement.width = displayWidth;
        canvasElement.height = displayHeight;

        for (var _i2 = 0, _Object$values2 = Object.values(this.pipelines); _i2 < _Object$values2.length; _i2++) {
          var pipeline = _Object$values2[_i2];
          pipeline.resize(displayWidth, displayHeight);
        }
      }
    }
  }, {
    key: "newBuffer",
    value: function newBuffer(callback) {
      var target = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.gl.ARRAY_BUFFER;
      var GL = this.gl;
      var buffer = GL.createBuffer();
      GL.bindBuffer(target, buffer);
      callback(buffer);
      GL.bindBuffer(target, null);

      if (this.errorChecking >= ERROR_CHECKING.SOME && GL.getError() !== GL.NO_ERROR) {
        throw new Error("GL error while constructing buffer");
      }

      return buffer;
    }
  }, {
    key: "newVertexArray",
    value: function newVertexArray(callback) {
      var GL = this.gl;
      var vao = GL.createVertexArray();
      GL.bindVertexArray(vao);
      callback(vao);
      GL.bindVertexArray(null);

      if (this.errorChecking >= ERROR_CHECKING.SOME && GL.getError() !== GL.NO_ERROR) {
        throw new Error("GL error while constructing vertex array");
      }

      return vao;
    }
  }, {
    key: "loadTexturesAsync",
    value: function () {
      var _loadTexturesAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee2(textureUrls) {
        var GL;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                GL = this.gl;
                _context2.next = 3;
                return Promise.all(textureUrls.map(
                /*#__PURE__*/
                function () {
                  var _ref = _asyncToGenerator(
                  /*#__PURE__*/
                  _regeneratorRuntime.mark(function _callee(desc) {
                    var image, texture, previousFlipValue, mipLevel, internalFormat, srcFormat, srcType;
                    return _regeneratorRuntime.wrap(function _callee$(_context) {
                      while (1) {
                        switch (_context.prev = _context.next) {
                          case 0:
                            image = new Image();
                            image.src = desc.url;
                            _context.next = 4;
                            return image.decode();

                          case 4:
                            texture = GL.createTexture();
                            GL.bindTexture(GL.TEXTURE_2D, texture);
                            GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_S, desc.wrap || GL.CLAMP_TO_EDGE);
                            GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_WRAP_T, desc.wrap || GL.CLAMP_TO_EDGE);
                            GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MIN_FILTER, desc.minFilter || GL.NEAREST);
                            GL.texParameteri(GL.TEXTURE_2D, GL.TEXTURE_MAG_FILTER, desc.magFilter || GL.NEAREST);
                            previousFlipValue = GL.getParameter(GL.UNPACK_FLIP_Y_WEBGL);
                            GL.pixelStorei(GL.UNPACK_FLIP_Y_WEBGL, true);
                            mipLevel = 0; // the largest mip

                            internalFormat = desc.internalFormat || GL.RGB; // format we want in the texture

                            srcFormat = desc.sourceFormat || GL.RGB; // format of data we are supplying

                            srcType = desc.sourcetype || GL.UNSIGNED_BYTE; // type of data we are supplying

                            GL.texImage2D(GL.TEXTURE_2D, mipLevel, internalFormat, srcFormat, srcType, image);
                            GL.pixelStorei(GL.UNPACK_FLIP_Y_WEBGL, previousFlipValue);
                            return _context.abrupt("return", texture);

                          case 19:
                          case "end":
                            return _context.stop();
                        }
                      }
                    }, _callee);
                  }));

                  return function (_x2) {
                    return _ref.apply(this, arguments);
                  };
                }()));

              case 3:
                return _context2.abrupt("return", _context2.sent);

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function loadTexturesAsync(_x) {
        return _loadTexturesAsync.apply(this, arguments);
      }

      return loadTexturesAsync;
    }()
  }, {
    key: "loadProgramAsync",
    value: function () {
      var _loadProgramAsync = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee3(vertexShaderUrl, fragmentShaderUrl, attributeLocationMappings, uniforms) {
        var shaderStreams, GL, vertexShader, fragmentShader, program, reverseMapping, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _ref4, _ref3, index, name, programUniforms, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, uniform;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return Promise.all([fetch(vertexShaderUrl), fetch(fragmentShaderUrl)]);

              case 2:
                shaderStreams = _context3.sent;
                GL = this.gl;
                vertexShader = GL.createShader(GL.VERTEX_SHADER);
                _context3.t0 = GL;
                _context3.t1 = vertexShader;
                _context3.next = 9;
                return shaderStreams[0].text();

              case 9:
                _context3.t2 = _context3.sent;

                _context3.t0.shaderSource.call(_context3.t0, _context3.t1, _context3.t2);

                GL.compileShader(vertexShader);

                if (GL.getShaderParameter(vertexShader, GL.COMPILE_STATUS)) {
                  _context3.next = 14;
                  break;
                }

                throw new Error("Error loading vertex shader: " + GL.getShaderInfoLog(vertexShader));

              case 14:
                fragmentShader = GL.createShader(GL.FRAGMENT_SHADER);
                _context3.t3 = GL;
                _context3.t4 = fragmentShader;
                _context3.next = 19;
                return shaderStreams[1].text();

              case 19:
                _context3.t5 = _context3.sent;

                _context3.t3.shaderSource.call(_context3.t3, _context3.t4, _context3.t5);

                GL.compileShader(fragmentShader);

                if (GL.getShaderParameter(fragmentShader, GL.COMPILE_STATUS)) {
                  _context3.next = 24;
                  break;
                }

                throw new Error("Error loading fragment shader: " + GL.getShaderInfoLog(fragmentShader));

              case 24:
                program = GL.createProgram();
                GL.attachShader(program, vertexShader);
                GL.attachShader(program, fragmentShader);
                reverseMapping = {};
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _iteratorError = undefined;
                _context3.prev = 31;

                for (_iterator = attributeLocationMappings.entries()[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                  _ref4 = _step.value;
                  _ref3 = _slicedToArray(_ref4, 2);
                  index = _ref3[0];
                  name = _ref3[1];

                  if (name) {
                    reverseMapping[name] = index;
                    GL.bindAttribLocation(program, index, name);
                    GL.enableVertexAttribArray(index);
                  }
                }

                _context3.next = 39;
                break;

              case 35:
                _context3.prev = 35;
                _context3.t6 = _context3["catch"](31);
                _didIteratorError = true;
                _iteratorError = _context3.t6;

              case 39:
                _context3.prev = 39;
                _context3.prev = 40;

                if (!_iteratorNormalCompletion && _iterator.return != null) {
                  _iterator.return();
                }

              case 42:
                _context3.prev = 42;

                if (!_didIteratorError) {
                  _context3.next = 45;
                  break;
                }

                throw _iteratorError;

              case 45:
                return _context3.finish(42);

              case 46:
                return _context3.finish(39);

              case 47:
                GL.linkProgram(program);

                if (GL.getProgramParameter(program, GL.LINK_STATUS)) {
                  _context3.next = 50;
                  break;
                }

                throw new Error("Could not link shader program: " + GL.getProgramInfoLog(program));

              case 50:
                programUniforms = {};
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _iteratorError2 = undefined;
                _context3.prev = 54;

                for (_iterator2 = uniforms[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                  uniform = _step2.value;
                  programUniforms[uniform] = GL.getUniformLocation(program, uniform);
                }

                _context3.next = 62;
                break;

              case 58:
                _context3.prev = 58;
                _context3.t7 = _context3["catch"](54);
                _didIteratorError2 = true;
                _iteratorError2 = _context3.t7;

              case 62:
                _context3.prev = 62;
                _context3.prev = 63;

                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                  _iterator2.return();
                }

              case 65:
                _context3.prev = 65;

                if (!_didIteratorError2) {
                  _context3.next = 68;
                  break;
                }

                throw _iteratorError2;

              case 68:
                return _context3.finish(65);

              case 69:
                return _context3.finish(62);

              case 70:
                return _context3.abrupt("return", {
                  program: program,
                  vertexShader: vertexShader,
                  fragmentShader: fragmentShader,
                  attributes: reverseMapping,
                  uniforms: programUniforms,
                  destroy: function destroy() {
                    GL.deleteProgram(this.program);
                    GL.deleteShader(this.vertexShader);
                    GL.deleteShader(this.fragmentShader);
                  }
                });

              case 71:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[31, 35, 39, 47], [40,, 42, 46], [54, 58, 62, 70], [63,, 65, 69]]);
      }));

      function loadProgramAsync(_x3, _x4, _x5, _x6) {
        return _loadProgramAsync.apply(this, arguments);
      }

      return loadProgramAsync;
    }()
  }, {
    key: "bindTextures",
    value: function bindTextures(textures, uniforms) {
      if (textures.length !== uniforms.length) {
        throw new Error("Unmatching length of textures array ".concat(textures.length, " and uniforms array ").concat(uniforms.length));
      }

      var GL = this.gl;

      for (var i = 0; i < textures.length; i++) {
        GL.activeTexture(GL["TEXTURE" + i]);
        GL.bindTexture(GL.TEXTURE_2D, textures[i]);
        GL.uniform1i(uniforms[i], i);
      }
    }
  }, {
    key: "bindArrayBuffer",
    value: function bindArrayBuffer(attributeLocation, buffer, elementSize) {
      var settings = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
      var GL = this.gl;
      GL.bindBuffer(GL.ARRAY_BUFFER, buffer);
      GL.enableVertexAttribArray(attributeLocation);
      var size = elementSize;
      var type = settings.type || GL.FLOAT;
      var normalize = settings.normalize || false;
      var stride = settings.stride || 0;
      var offset = settings.offset || 0;
      GL.vertexAttribPointer(attributeLocation, size, type, normalize, stride, offset);

      if (this.errorChecking >= ERROR_CHECKING.SOME && GL.getError() !== GL.NO_ERROR) {
        throw new Error("GL error while binding unit quad buffer");
      }

      GL.bindBuffer(GL.ARRAY_BUFFER, null);
    }
  }, {
    key: "newMesh",
    value: function newMesh() {
      return new Mesh(this);
    }
  }, {
    key: "getUnitQuadMesh",
    value: function getUnitQuadMesh() {
      return this.unitQuadMesh;
    }
  }, {
    key: "getUnitCubeMesh",
    value: function getUnitCubeMesh() {
      return this.unitCubeMesh;
    }
  }, {
    key: "getCentered2x2CubeMesh",
    value: function getCentered2x2CubeMesh() {
      return this.centered2x2CubeMesh;
    }
  }, {
    key: "loadWavefrontObject",
    value: function () {
      var _loadWavefrontObject = _asyncToGenerator(
      /*#__PURE__*/
      _regeneratorRuntime.mark(function _callee4(fileUrl) {
        var loadTransformMatrix,
            normalMatrix,
            stream,
            text,
            lines,
            vertexPositions,
            textureCoords,
            normals,
            faceVertexIndexKeys,
            line,
            vertexPositionsArray,
            textureCoordsArray,
            normalsArray,
            faceVertexIndices,
            nextIndex,
            indices,
            _iteratorNormalCompletion3,
            _didIteratorError3,
            _iteratorError3,
            _iterator3,
            _step3,
            key,
            _key$split$map,
            _key$split$map2,
            positionIndex,
            textureCoordIndex,
            normalIndex,
            mesh,
            _args4 = arguments;

        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                loadTransformMatrix = _args4.length > 1 && _args4[1] !== undefined ? _args4[1] : mat4.create();
                normalMatrix = mat3.normalFromMat4(mat3.create(), loadTransformMatrix);
                _context4.next = 4;
                return fetch(fileUrl);

              case 4:
                stream = _context4.sent;
                _context4.next = 7;
                return stream.text();

              case 7:
                text = _context4.sent;
                lines = text.split('\n');
                vertexPositions = [];
                textureCoords = [];
                normals = [];
                faceVertexIndexKeys = [];

                while (lines.length > 0) {
                  line = lines.shift();

                  if (!line.startsWith('#')) {
                    (function () {
                      var words = line.split(' ');
                      var firstWord = words.shift();

                      var numbers = function numbers() {
                        return words.map(function (w) {
                          return Number(w);
                        });
                      };

                      switch (firstWord) {
                        case 'v':
                          var position = numbers();
                          var transformedPosition = vec3.transformMat4(vec3.create(), vec3.fromValues(position[0], position[1], position[2]), loadTransformMatrix);
                          vertexPositions.push([transformedPosition[0], transformedPosition[1], transformedPosition[2]]);
                          break;

                        case 'vt':
                          textureCoords.push(numbers());
                          break;

                        case 'vn':
                          var normal = numbers();
                          var transformedNormal = vec3.transformMat3(vec3.create(), vec3.fromValues(normal[0], normal[1], normal[2]), normalMatrix);
                          normals.push([transformedNormal[0], transformedNormal[1], transformedNormal[2]]);
                          break;

                        case 'f':
                          faceVertexIndexKeys.push(words);
                          break;
                      }
                    })();
                  }
                }

                vertexPositionsArray = [];
                textureCoordsArray = [];
                normalsArray = [];
                faceVertexIndices = [];
                nextIndex = 0;
                indices = {};
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _iteratorError3 = undefined;
                _context4.prev = 23;

                for (_iterator3 = faceVertexIndexKeys.flat()[Symbol.iterator](); !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
                  key = _step3.value;

                  if (indices[key] !== undefined) {
                    faceVertexIndices.push(indices[key]);
                  } else {
                    _key$split$map = key.split('/').map(function (w) {
                      return Number(w);
                    }), _key$split$map2 = _slicedToArray(_key$split$map, 3), positionIndex = _key$split$map2[0], textureCoordIndex = _key$split$map2[1], normalIndex = _key$split$map2[2];
                    indices[key] = nextIndex;
                    vertexPositionsArray.push(vertexPositions[positionIndex - 1]);
                    if (textureCoords.length > 0) textureCoordsArray.push(textureCoords[textureCoordIndex - 1]);
                    if (normals.length > 0) normalsArray.push(normals[normalIndex - 1]);
                    faceVertexIndices.push(nextIndex);
                    nextIndex += 1;
                  }
                }

                _context4.next = 31;
                break;

              case 27:
                _context4.prev = 27;
                _context4.t0 = _context4["catch"](23);
                _didIteratorError3 = true;
                _iteratorError3 = _context4.t0;

              case 31:
                _context4.prev = 31;
                _context4.prev = 32;

                if (!_iteratorNormalCompletion3 && _iterator3.return != null) {
                  _iterator3.return();
                }

              case 34:
                _context4.prev = 34;

                if (!_didIteratorError3) {
                  _context4.next = 37;
                  break;
                }

                throw _iteratorError3;

              case 37:
                return _context4.finish(34);

              case 38:
                return _context4.finish(31);

              case 39:
                mesh = this.newMesh().setPositions(vertexPositionsArray);
                if (textureCoordsArray.length > 0) mesh.setColorUVCoords(textureCoordsArray);
                if (normalsArray.length > 0) mesh.setNormals(normalsArray);
                return _context4.abrupt("return", mesh.setTriangleIndices(faceVertexIndices));

              case 43:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[23, 27, 31, 39], [32,, 34, 38]]);
      }));

      function loadWavefrontObject(_x7) {
        return _loadWavefrontObject.apply(this, arguments);
      }

      return loadWavefrontObject;
    }()
  }, {
    key: "internalCreateUnitQuad",
    value: function internalCreateUnitQuad() {
      this.unitQuadMesh = this.newMesh().setPositions([0, 1, 0, 0, 0, 0, 1, 0, 0, 1, 1, 0, 0, 1, 0, 1, 0, 0]).setNormals([0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1]).setColorUVCoords([0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0]).setNormalUVCoords([0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0]).setSpecularUVCoords([0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0]);
    }
  }, {
    key: "internalCreateUnitCube",
    value: function internalCreateUnitCube() {
      var uvCoords = [[0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 1, 0], [0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0], [0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 1], [0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1], [0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0], [1, 0, 1, 1, 0, 0, 1, 1, 0, 1, 0, 0]];
      this.unitCubeMesh = this.newMesh().setPositions([[0, 0, 0, 0, 1, 0, 1, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0], [0, 1, 1, 0, 0, 1, 1, 0, 1, 1, 1, 1, 0, 1, 1, 1, 0, 1], [0, 1, 0, 0, 0, 0, 0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 0, 1], [1, 0, 0, 1, 1, 0, 1, 0, 1, 1, 1, 0, 1, 1, 1, 1, 0, 1], [0, 0, 1, 0, 0, 0, 1, 0, 0, 1, 0, 1, 0, 0, 1, 1, 0, 0], [0, 1, 0, 0, 1, 1, 1, 1, 0, 0, 1, 1, 1, 1, 1, 1, 1, 0]]).setNormals([[0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1], [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1], [-1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0], [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0], [0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0], [0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0]]).setColorUVCoords(uvCoords).setNormalUVCoords(uvCoords).setSpecularUVCoords(uvCoords);
    }
  }, {
    key: "internalCreateCentered2x2Cube",
    value: function internalCreateCentered2x2Cube() {
      var uvCoords = [[0, 0, 0, 1, 1, 0, 0, 1, 1, 1, 1, 0], [0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0], [0, 0, 1, 0, 1, 1, 0, 1, 0, 0, 1, 1], [0, 0, 1, 0, 0, 1, 1, 0, 1, 1, 0, 1], [0, 1, 0, 0, 1, 0, 1, 1, 0, 1, 1, 0], [1, 0, 1, 1, 0, 0, 1, 1, 0, 1, 0, 0]];
      this.centered2x2CubeMesh = this.newMesh().setPositions([[-1, -1, -1, -1, 1, -1, 1, -1, -1, -1, 1, -1, 1, 1, -1, 1, -1, -1], [-1, 1, 1, -1, -1, 1, 1, -1, 1, 1, 1, 1, -1, 1, 1, 1, -1, 1], [-1, 1, -1, -1, -1, -1, -1, -1, 1, -1, 1, 1, -1, 1, -1, -1, -1, 1], [1, -1, -1, 1, 1, -1, 1, -1, 1, 1, 1, -1, 1, 1, 1, 1, -1, 1], [-1, -1, 1, -1, -1, -1, 1, -1, -1, 1, -1, 1, -1, -1, 1, 1, -1, -1], [-1, 1, -1, -1, 1, 1, 1, 1, -1, -1, 1, 1, 1, 1, 1, 1, 1, -1]]).setNormals([[0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1], [0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1], [-1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0], [1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0], [0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0], [0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0]]).setColorUVCoords(uvCoords).setNormalUVCoords(uvCoords).setSpecularUVCoords(uvCoords);
    }
  }, {
    key: "shaders",
    get: function get() {
      return {
        vertex: {
          position: require("./basicRenderers/shaders/position.vert"),
          fullscreenquad: require("./basicRenderers/shaders/fullscreenquad.vert")
        },
        fragment: {
          depth: require("./basicRenderers/shaders/depth.frag"),
          empty: require("./basicRenderers/shaders/depth.frag") // alias

        }
      };
    }
  }]);

  return GlassContext;
}();